import React from 'react'
import { Link } from 'react-router-dom'

function About() {
    return (
        <div className="About-page">
            <h1>About Page</h1>
            <div className="container">
                    <img src="https://via.placeholder.com/100x35" alt="logo" />
                    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ad, hic. Quibusdam quis officia aperiam provident!</p>
                </div>
             {/* <p>footee!</p> */}
             <div className="row">
             
                <div className="col-sm-12 col-md-4">
                    <h3>Website By:</h3>
                    <div className="profile-card">
                        <img src="https://via.placeholder.com/100x35" alt="profile" className="user-profile"/>
                        <div className="user-details">
                            <h4>Aditya Ranjan Mishra</h4>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Vitae nobis eius nisi ut quam dolorem!</p>
                            <a href="#">dksnfk</a>
                            <a href="#">dksnfk</a>
                            <a href="#">dksnfk</a>
                        </div>
                    </div>
                    <div className="profile-card">
                        <img src="https://via.placeholder.com/100x35" alt="profile" className="user-profile"/>
                        <div className="user-details">
                            <h4>B Kanhu Charan</h4>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Vitae nobis eius nisi ut quam dolorem!</p>
                            <a href="#">dksnfk</a>
                            <a href="#">dksnfk</a>
                            <a href="#">dksnfk</a>
                        </div>
                    </div>
                </div>
                <div className="col-sm-12 col-md-4">
                    <h3>Menu</h3>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/about">About Us</Link></li>
                        <li><Link to="/contact">Contact Us</Link></li>
                    </ul>
                    
                    
                    
                </div>
            </div>
        </div>
    )
}

export default About
